module.exports = "/images/package_not_available.svg";